import { Component } from '@angular/core';
import {AuthenticationService} from './authentication/authentication.service';
import {HttpClient} from '@angular/common/http';
import {MY_AGENTS_URL} from './api-config';
import {UserData} from './authentication/user.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  user: UserData | undefined;
  agents: any;

  constructor(authenticationService: AuthenticationService, httpClient: HttpClient) {
    authenticationService.triggerLogin();
    authenticationService.authenticatedUser.subscribe(u => {
      this.user = u;
      httpClient.get<any>(MY_AGENTS_URL).subscribe(a => this.agents = a);
    });
  }
}
